import React from 'react';

import flags from '@swf/core/assets/flags';
import type { LiveCasinoGame } from '@swf/core/types/CasinoGame';

interface Props {
  game?: LiveCasinoGame;
}

const FlagIcon: React.FC<Props> = ({ game }) => {
  const src = flags[game?.statusMeta?.lang?.toUpperCase()];
  return src ? <img src={src} alt="" /> : null;
};

export default FlagIcon;
